import { useRouter } from "next/router";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import settingsModel from "../../models/settings.model";
import useSWR from 'swr'
import Heading from "../../components/Heading.js";
import Link from "next/link";
import SettingsLayout from "./SettingsLayout";
import helper from "../../lib/helper";
import config from "../../lib/config";
import vendorpincodeModel from "../../models/vendorpincode.model.js";
const Page = function () {

    const router = useRouter()
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { errors, isSubmitting },
        setError,
        reset
    } = useForm();

    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await vendorpincodeModel.create(formData).then((response) => {
            helper.sweetalert.toast(response?.data?.message, 'success');

        }).catch(error => {
            setError('title', { type: 'required', message: error.response?.data?.errors?.title });
        })
    });



    return (
        <>

            <SettingsLayout title="Settings">
                <div className="tab-pane active" id="profile">

                <h6 className="card-header">Upload pincodes</h6>
                    <form onSubmit={onSubmit} className="form-control">
                  
                        <div className="row">
                            <div className="col-md-3 mt-1 mb-1">

                                <input type="file" {...register('vendor_pincodes')} />
                                <button type="submit" className="btn btn-sm btn-primary float-end mt-1">Upload</button>

                            </div>
                        </div>
                    </form>
                </div>

            </SettingsLayout>
        </>
    );
};

export default Page;